export const getRoleDisplay = (user) => {
  if (user && user.role) {
    if (Array.isArray(user.role) && user.role.length > 0) {
      // Join multiple roles with a comma and space if it's an array with roles
      return user.role.join(", ");
    } else if (typeof user.role === "string" && user.role.trim() !== "") {
      // If user.role is a non-empty string, return it directly
      return user.role;
    }
  }
  // Fallback to "Normal User" if there are no roles or user.role is undefined/empty
  return "Normal User";
  // return user.role;
};
